export const adicionarRegra = 'AdicionarRegra';
export const removerRegra = 'RemoverRegra';
export const editarRegra = 'EditarRegra';
export const aplicarRegra = 'AplicarRegra';
export const listarRegras = 'ListarRegras';
export const listarUsuarios = 'ListarUsuarios';
export const regras = [adicionarRegra, removerRegra, editarRegra, aplicarRegra, listarRegras, listarUsuarios];
